import { Circle, Layer, Rect, Stage } from "react-konva";
import windowDimension from "../../../../utils/windowDimension";
import { CanvasWrapper } from "./forgot-password-canvas.styles";
import React from "react";

const ForgotPasswordCanvas = () => {
  const canvasHeight = windowDimension().height;
  const canvasWidth = 0.67 * windowDimension().width;

  return (
    <CanvasWrapper>
      <Stage width={canvasWidth} height={canvasHeight}>
        <Layer>
          <Circle
            x={canvasWidth * 0.7}
            y={-0.35 * canvasHeight}
            radius={canvasHeight * 1.3}
            fill="#ffffff22"
          />
          <Circle
            x={canvasWidth * 0.55}
            y={-0.12 * canvasHeight}
            radius={canvasHeight}
            fill="#ffffff33"
          />
          <Rect
            x={canvasWidth * 0.1}
            y={canvasWidth * 0.28}
            width={canvasWidth * 0.23}
            height={canvasHeight * 0.28}
            fill="#96969644"
          />
          <Rect
            x={canvasWidth * 0.75}
            y={0}
            width={canvasWidth * 0.25}
            height={canvasHeight * 0.3}
            fill="#96969644"
          />
          <Rect
            x={canvasWidth * 0.76}
            y={canvasHeight * 0.7}
            width={canvasWidth * 0.24}
            height={canvasHeight * 0.3}
            fill="#96969644"
          />
        </Layer>
      </Stage>
    </CanvasWrapper>
  );
};

export default ForgotPasswordCanvas;
